export default "https://cdn-static.gokick.com/assets/e031f09406d9a12f4f19fb28fc50e3428375be91/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";